"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_REGIONS = exports.FileDownloader = exports.FileUploader = exports.isNull = exports.currencyFormatter = exports.localString = exports.getDateRange = exports.hasPermission = exports.validateProjectCode = exports.validateEmail = exports.validateText = exports.validatePhone = exports.validateAlpha = exports.validateLowercaseAlpha = exports.fileSize2 = exports.fileSize = exports.CURRENCIES = exports.COUNTRIES = exports.timeDiff = exports.timeFromNow = exports.localTime = exports.localDateTime = exports.localDateShort = exports.localDate = exports.post = void 0;
exports.WebsocketConnect = WebsocketConnect;
exports.dataURItoBlob = dataURItoBlob;
exports.uploadFileToS3 = uploadFileToS3;
exports.selectFile = selectFile;
const dayjs_1 = __importDefault(require("dayjs"));
const post = (url_1, ...args_1) => __awaiter(void 0, [url_1, ...args_1], void 0, function* (url, body = {}, method = "GET", files = null, file = null) {
    const csrfElement = document.querySelector("[name=csrfmiddlewaretoken]");
    const csrftoken = csrfElement ? csrfElement.value : "";
    const headers = {
        "X-CSRFToken": csrftoken,
    };
    if (method === "GET") {
        const get_params = new URLSearchParams(body).toString();
        url = url + "?" + get_params;
    }
    const args = {
        method,
        credentials: "same-origin",
        headers,
        body: null,
    };
    if (method !== "GET") {
        if (files) {
            const form_data = new FormData();
            for (let i = 0; i < files.length; i++) {
                form_data.append("file" + i, files[i]);
            }
            for (let key in body) {
                form_data.set(key, body[key]);
            }
            args.body = form_data;
        }
        else if (file) {
            const form_data = new FormData();
            form_data.append("file", file);
            for (let key in body) {
                form_data.set(key, body[key]);
            }
            args.body = form_data;
        }
        else {
            args.body = JSON.stringify(body);
            headers["Content-Type"] = "application/json; charset=UTF-8";
        }
    }
    try {
        const response = yield fetch(url, args);
        if (response.ok) {
            const content_type = response.headers.get("Content-Type");
            if (content_type === "text/html; charset=utf-8") {
                return response.text();
            }
            else if (content_type === "application/json") {
                return response.json();
            }
            else {
                return response;
            }
        }
        else {
            let error = yield response.text();
            throw error;
        }
    }
    catch (error) {
        throw error;
    }
});
exports.post = post;
const localDate = (string) => {
    if (string == null || string == "" || string == "Invalid Date")
        return "-";
    let dt = (0, dayjs_1.default)(string);
    // if (!(string instanceof Date)) {
    //     dt = dayjs(string)
    // }
    return dt.format("MMM DD, YYYY");
};
exports.localDate = localDate;
const localDateShort = (string) => {
    if (string == null || string == "" || string == "Invalid Date")
        return "-";
    let dt = (0, dayjs_1.default)(string);
    // if (!(string instanceof Date)) {
    //     dt = dayjs(string)
    // }
    return dt.format("MMM D");
};
exports.localDateShort = localDateShort;
const localDateTime = (string) => {
    if (string == null || string == "" || string == "Invalid Date")
        return "-";
    let dt = (0, dayjs_1.default)(string);
    // if (!(string instanceof Date)) {
    //     dt = dayjs(string)
    // }
    return dt.format("MMM D, YYYY h:mm:ss a");
};
exports.localDateTime = localDateTime;
const localTime = (string) => {
    if (string == null || string == "" || string == "Invalid Date")
        return "-";
    let dt = (0, dayjs_1.default)(string);
    // if (!(string instanceof Date)) {
    //     dt = dayjs(string)
    // }
    return dt.format("h:mm a");
};
exports.localTime = localTime;
const timeFromNow = (string) => {
    if (string == null || string == "" || string == "Invalid Date")
        return "-";
    let dt = (0, dayjs_1.default)(string);
    // @ts-ignore
    return dt.fromNow();
};
exports.timeFromNow = timeFromNow;
const timeDiff = (start_time, end_time, short = false) => {
    if (start_time == null || end_time === null)
        return "-";
    let dt1 = start_time;
    if (!(start_time instanceof Date)) {
        dt1 = new Date(start_time);
    }
    let dt2 = end_time;
    if (!(end_time instanceof Date)) {
        dt2 = new Date(end_time);
    }
    // Calculate the difference in milliseconds
    const diffInMilliseconds = Math.abs(dt2 - dt1);
    // Convert to seconds
    const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
    // Calculate hours
    const hours = Math.floor(diffInSeconds / 3600);
    // Calculate remaining minutes
    const remainingMinutesInSeconds = diffInSeconds % 3600;
    const minutes = Math.floor(remainingMinutesInSeconds / 60);
    // Calculate remaining seconds
    const seconds = remainingMinutesInSeconds % 60;
    if (short) {
        return `${hours}.${minutes}`;
    }
    else {
        return `${hours}h ${minutes}m`;
    }
};
exports.timeDiff = timeDiff;
exports.COUNTRIES = [
    { code: "AF", name: "Afghanistan" },
    { code: "AL", name: "Albania" },
    { code: "DZ", name: "Algeria" },
    { code: "AD", name: "Andorra" },
    { code: "AO", name: "Angola" },
    { code: "AG", name: "Antigua and Barbuda" },
    { code: "AR", name: "Argentina" },
    { code: "AM", name: "Armenia" },
    { code: "AU", name: "Australia" },
    { code: "AT", name: "Austria" },
    { code: "AZ", name: "Azerbaijan" },
    { code: "BS", name: "Bahamas" },
    { code: "BH", name: "Bahrain" },
    { code: "BD", name: "Bangladesh" },
    { code: "BB", name: "Barbados" },
    { code: "BY", name: "Belarus" },
    { code: "BE", name: "Belgium" },
    { code: "BZ", name: "Belize" },
    { code: "BJ", name: "Benin" },
    { code: "BT", name: "Bhutan" },
    { code: "BO", name: "Bolivia" },
    { code: "BA", name: "Bosnia and Herzegovina" },
    { code: "BW", name: "Botswana" },
    { code: "BR", name: "Brazil" },
    { code: "BN", name: "Brunei" },
    { code: "BG", name: "Bulgaria" },
    { code: "BF", name: "Burkina Faso" },
    { code: "BI", name: "Burundi" },
    { code: "CV", name: "Cabo Verde" },
    { code: "KH", name: "Cambodia" },
    { code: "CM", name: "Cameroon" },
    { code: "CA", name: "Canada" },
    { code: "CF", name: "Central African Republic" },
    { code: "TD", name: "Chad" },
    { code: "CL", name: "Chile" },
    { code: "CN", name: "China" },
    { code: "CO", name: "Colombia" },
    { code: "KM", name: "Comoros" },
    { code: "CD", name: "Congo (Democratic Republic)" },
    { code: "CG", name: "Congo (Republic)" },
    { code: "CR", name: "Costa Rica" },
    { code: "CI", name: "Cote d Ivoire" },
    { code: "HR", name: "Croatia" },
    { code: "CU", name: "Cuba" },
    { code: "CY", name: "Cyprus" },
    { code: "CZ", name: "Czech Republic" },
    { code: "DK", name: "Denmark" },
    { code: "DJ", name: "Djibouti" },
    { code: "DM", name: "Dominica" },
    { code: "DO", name: "Dominican Republic" },
    { code: "EC", name: "Ecuador" },
    { code: "EG", name: "Egypt" },
    { code: "SV", name: "El Salvador" },
    { code: "GQ", name: "Equatorial Guinea" },
    { code: "ER", name: "Eritrea" },
    { code: "EE", name: "Estonia" },
    { code: "SZ", name: "Eswatini" },
    { code: "ET", name: "Ethiopia" },
    { code: "FJ", name: "Fiji" },
    { code: "FI", name: "Finland" },
    { code: "FR", name: "France" },
    { code: "GA", name: "Gabon" },
    { code: "GM", name: "Gambia" },
    { code: "GE", name: "Georgia" },
    { code: "DE", name: "Germany" },
    { code: "GH", name: "Ghana" },
    { code: "GR", name: "Greece" },
    { code: "GD", name: "Grenada" },
    { code: "GT", name: "Guatemala" },
    { code: "GN", name: "Guinea" },
    { code: "GW", name: "Guinea-Bissau" },
    { code: "GY", name: "Guyana" },
    { code: "HT", name: "Haiti" },
    { code: "HN", name: "Honduras" },
    { code: "HU", name: "Hungary" },
    { code: "IS", name: "Iceland" },
    { code: "IN", name: "India" },
    { code: "ID", name: "Indonesia" },
    { code: "IR", name: "Iran" },
    { code: "IQ", name: "Iraq" },
    { code: "IE", name: "Ireland" },
    { code: "IL", name: "Israel" },
    { code: "IT", name: "Italy" },
    { code: "JM", name: "Jamaica" },
    { code: "JP", name: "Japan" },
    { code: "JO", name: "Jordan" },
    { code: "KZ", name: "Kazakhstan" },
    { code: "KE", name: "Kenya" },
    { code: "KI", name: "Kiribati" },
    { code: "KP", name: "Korea (North)" },
    { code: "KR", name: "Korea (South)" },
    { code: "KW", name: "Kuwait" },
    { code: "KG", name: "Kyrgyzstan" },
    { code: "LA", name: "Laos" },
    { code: "LV", name: "Latvia" },
    { code: "LB", name: "Lebanon" },
    { code: "LS", name: "Lesotho" },
    { code: "LR", name: "Liberia" },
    { code: "LY", name: "Libya" },
    { code: "LI", name: "Liechtenstein" },
    { code: "LT", name: "Lithuania" },
    { code: "LU", name: "Luxembourg" },
    { code: "MG", name: "Madagascar" },
    { code: "MW", name: "Malawi" },
    { code: "MY", name: "Malaysia" },
    { code: "MV", name: "Maldives" },
    { code: "ML", name: "Mali" },
    { code: "MT", name: "Malta" },
    { code: "MH", name: "Marshall Islands" },
    { code: "MR", name: "Mauritania" },
    { code: "MU", name: "Mauritius" },
    { code: "MX", name: "Mexico" },
    { code: "FM", name: "Micronesia" },
    { code: "MD", name: "Moldova" },
    { code: "MC", name: "Monaco" },
    { code: "MN", name: "Mongolia" },
    { code: "ME", name: "Montenegro" },
    { code: "MA", name: "Morocco" },
    { code: "MZ", name: "Mozambique" },
    { code: "MM", name: "Myanmar" },
    { code: "NA", name: "Namibia" },
    { code: "NR", name: "Nauru" },
    { code: "NP", name: "Nepal" },
    { code: "NL", name: "Netherlands" },
    { code: "NZ", name: "New Zealand" },
    { code: "NI", name: "Nicaragua" },
    { code: "NE", name: "Niger" },
    { code: "NG", name: "Nigeria" },
    { code: "MK", name: "North Macedonia" },
    { code: "NO", name: "Norway" },
    { code: "OM", name: "Oman" },
    { code: "PK", name: "Pakistan" },
    { code: "PW", name: "Palau" },
    { code: "PA", name: "Panama" },
    { code: "PG", name: "Papua New Guinea" },
    { code: "PY", name: "Paraguay" },
    { code: "PE", name: "Peru" },
    { code: "PH", name: "Philippines" },
    { code: "PL", name: "Poland" },
    { code: "PT", name: "Portugal" },
    { code: "QA", name: "Qatar" },
    { code: "RO", name: "Romania" },
    { code: "RU", name: "Russia" },
    { code: "RW", name: "Rwanda" },
    { code: "KN", name: "Saint Kitts and Nevis" },
    { code: "LC", name: "Saint Lucia" },
    { code: "VC", name: "Saint Vincent and the Grenadines" },
    { code: "WS", name: "Samoa" },
    { code: "SM", name: "San Marino" },
    { code: "ST", name: "Sao Tome and Principe" },
    { code: "SA", name: "Saudi Arabia" },
    { code: "SN", name: "Senegal" },
    { code: "RS", name: "Serbia" },
    { code: "SC", name: "Seychelles" },
    { code: "SL", name: "Sierra Leone" },
    { code: "SG", name: "Singapore" },
    { code: "SK", name: "Slovakia" },
    { code: "SI", name: "Slovenia" },
    { code: "SB", name: "Solomon Islands" },
    { code: "SO", name: "Somalia" },
    { code: "ZA", name: "South Africa" },
    { code: "SS", name: "South Sudan" },
    { code: "ES", name: "Spain" },
    { code: "LK", name: "Sri Lanka" },
    { code: "SD", name: "Sudan" },
    { code: "SR", name: "Suriname" },
    { code: "SE", name: "Sweden" },
    { code: "CH", name: "Switzerland" },
    { code: "SY", name: "Syria" },
    { code: "TJ", name: "Tajikistan" },
    { code: "TZ", name: "Tanzania" },
    { code: "TH", name: "Thailand" },
    { code: "TL", name: "Timor-Leste" },
    { code: "TG", name: "Togo" },
    { code: "TO", name: "Tonga" },
    { code: "TT", name: "Trinidad and Tobago" },
    { code: "TN", name: "Tunisia" },
    { code: "TR", name: "Turkey" },
    { code: "TM", name: "Turkmenistan" },
    { code: "TV", name: "Tuvalu" },
    { code: "UG", name: "Uganda" },
    { code: "UA", name: "Ukraine" },
    { code: "AE", name: "United Arab Emirates" },
    { code: "GB", name: "United Kingdom" },
    { code: "US", name: "United States" },
    { code: "UY", name: "Uruguay" },
    { code: "UZ", name: "Uzbekistan" },
    { code: "VU", name: "Vanuatu" },
    { code: "VE", name: "Venezuela" },
    { code: "VN", name: "Vietnam" },
    { code: "YE", name: "Yemen" },
    { code: "ZM", name: "Zambia" },
    { code: "ZW", name: "Zimbabwe" },
];
exports.CURRENCIES = ["INR", "USD", "GBP", "JPY", "EUR"];
const fileSize = (bytes) => {
    if (bytes === 0)
        return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KiB", "MiB", "GiB", "TiB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
exports.fileSize = fileSize;
const fileSize2 = (bytes) => {
    if (bytes === 0)
        return "0 Bytes";
    const k = 1000;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
exports.fileSize2 = fileSize2;
const validateLowercaseAlpha = (text) => {
    const re = /^[a-z0-9]+$/;
    return re.test(text);
};
exports.validateLowercaseAlpha = validateLowercaseAlpha;
const validateAlpha = (text) => {
    const re = /^[a-zA-Z0-9]+$/;
    return re.test(text);
};
exports.validateAlpha = validateAlpha;
const validatePhone = (text) => {
    const re = /^\+?[0-9 -]{10,15}$/;
    return re.test(text);
};
exports.validatePhone = validatePhone;
const validateText = (text) => {
    const re = /^[a-zA-Z0-9 ]+$/;
    return re.test(text);
};
exports.validateText = validateText;
const validateEmail = (email) => {
    const re = /^[a-zA-Z]+[a-zA-Z0-9.-_]*@[a-zA-Z-?]+\.[a-zA-Z0-9.-]*$/;
    return re.test(email);
};
exports.validateEmail = validateEmail;
const validateProjectCode = (code) => {
    const re = /^[a-zA-Z][a-zA-Z0-9_]{2,9}$/;
    return re.test(code);
};
exports.validateProjectCode = validateProjectCode;
const hasPermission = (user, permission) => {
    return user.permissions.indexOf(permission) !== -1;
};
exports.hasPermission = hasPermission;
const getDateRange = (start, end) => {
    const range = [];
    let current = start;
    while (!current.isAfter(end)) {
        range.push(current);
        current = current.add(1, "days");
    }
    return range;
};
exports.getDateRange = getDateRange;
const localString = (value, round = 2) => {
    if (value == null)
        return "-";
    return value.toLocaleString("en-US", {
        style: "decimal",
        maximumFractionDigits: round,
        minimumFractionDigits: round,
    });
};
exports.localString = localString;
const currencySymbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    INR: "₹",
};
const currencyFormatter = (value, currency, round = 2) => {
    if (value == null || currency == null)
        return "-";
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
        minimumFractionDigits: round,
        maximumFractionDigits: round,
    });
    return formatter.format(value);
};
exports.currencyFormatter = currencyFormatter;
const isNull = (value) => {
    return value === null || value === undefined || value === "" || value === 0;
};
exports.isNull = isNull;
function WebsocketConnect(socket, path, onMessage) {
    let wss_path = `wss://wss.dev.localhost`;
    if (window.location.host === "repo.chacess.app") {
        wss_path = `wss://wss.chacess.app`;
    }
    socket.current = new WebSocket(wss_path + path);
    socket.current.binaryType = "arraybuffer";
    socket.current.onopen = () => { };
    socket.current.onmessage = onMessage;
    socket.current.onclose = () => {
        setTimeout(() => {
            WebsocketConnect(socket, path, onMessage);
        }, 1000);
    };
    socket.current.onerror = (error) => {
        console.error("Socket Error", error);
    };
}
// Helper function to convert dataURI to Blob
function dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
}
/**
 * Uploads a file to S3 using a pre-signed URL and tracks progress.
 * @param {File} file - The file to upload.
 * @param {string} presignedUrl - The pre-signed URL for S3.
 * @param {function} onProgress - Callback to handle progress tracking.
 * @returns {Promise} - Resolves when the upload is complete.
 */
function uploadFileToS3(file, presignedUrl, onProgress) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            // Track the progress of the upload
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentage = Math.round((event.loaded / event.total) * 100);
                    onProgress(percentage); // Update progress callback
                }
            };
            // Setup the request
            xhr.open("PUT", presignedUrl, true);
            xhr.setRequestHeader("Content-Type", file.type); // Set content type
            // Handle successful upload
            xhr.onload = function () {
                if (xhr.status === 200) {
                    resolve(xhr.response); // Upload successful
                }
                else {
                    reject(new Error(`Upload failed with status ${xhr.status}`)); // Error handling
                }
            };
            // Handle network errors
            xhr.onerror = function () {
                reject(new Error("Network error occurred during upload"));
            };
            // Start uploading the file
            xhr.send(file);
        });
    });
}
// let fileManagerWorker = new Worker(
//     `https://${window.location.host}/worker/fileManager/`
// );
// // Send a message to the worker
// function fileManagerAction(
//     action: string,
//     fileName: string,
//     message: any = null
// ) {
//     return new Promise((resolve, reject) => {
//         // Listen for the worker's response
//         fileManagerWorker.onmessage = (event: any) => {
//             const { success, data, error } = event.data;
//             if (success) {
//                 resolve(data);
//             } else {
//                 reject(error);
//             }
//         };
//         // Post the action and necessary data to the worker
//         fileManagerWorker.postMessage({ action, fileName, message });
//     });
// }
const pickerOpts = {
    types: [
        {
            description: "Attachments",
            accept: {
                "image/*": [".png", ".gif", ".jpeg", ".jpg"],
                "file/*": [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".txt", ".csv"],
            },
        },
    ],
    excludeAcceptAllOption: true,
    multiple: false,
};
function selectFile() {
    return __awaiter(this, void 0, void 0, function* () {
        // @ts-ignore
        const [fileHandle] = yield window.showOpenFilePicker(pickerOpts);
        const file = yield fileHandle.getFile();
        console.log(file);
    });
}
class FileUploader {
    constructor() {
        this.directoryHandle = null;
        this.totalSize = 0;
        this.totalFiles = 0;
        this.files = [];
    }
    // Request permission for a directory handle
    requestPermission(directoryHandle) {
        return __awaiter(this, void 0, void 0, function* () {
            const opts = { mode: "read" };
            // Check if permission is already granted
            // @ts-ignore
            if ((yield directoryHandle.queryPermission(opts)) === "granted") {
                return true;
            }
            // Request permission and return the result
            // @ts-ignore
            return (yield directoryHandle.requestPermission(opts)) === "granted";
        });
    }
    // Select a folder and request permissions
    selectDirectory() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, e_1, _b, _c;
            // Show directory picker
            // @ts-ignore
            this.directoryHandle = yield window.showDirectoryPicker();
            if (!this.directoryHandle) {
                console.error("No directory was selected.");
                return;
            }
            // Request permissions
            const hasPermission = yield this.requestPermission(this.directoryHandle);
            if (!hasPermission) {
                console.error("Permission was not granted for the selected folder.");
                return;
            }
            try {
                // Get files recursively
                for (var _d = true, _e = __asyncValues(this.getFilesRecursively(this.directoryHandle)), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
                    _c = _f.value;
                    _d = false;
                    const file = _c;
                    this.totalSize += file.size;
                    this.totalFiles++;
                    this.files.push(file);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    }
    // Get relative path of an entry within the directory
    getRelativePath(entry) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.directoryHandle) {
                console.error("Directory handle is not set.");
                return undefined;
            }
            const path = yield this.directoryHandle.resolve(entry);
            // remove the file name from the path
            path === null || path === void 0 ? void 0 : path.pop();
            return path === null || path === void 0 ? void 0 : path.join("/");
        });
    }
    // Recursively retrieve files
    getFilesRecursively(entry) {
        return __asyncGenerator(this, arguments, function* getFilesRecursively_1() {
            var _a, e_2, _b, _c;
            if (entry.name.startsWith(".")) {
                return yield __await(void 0);
            }
            if (entry.kind === "file") {
                // @ts-ignore
                const file = yield __await(entry.getFile());
                if (file) {
                    file.path = yield __await(this.getRelativePath(entry));
                    yield yield __await(file);
                }
            }
            else if (entry.kind === "directory") {
                try {
                    // @ts-ignore
                    for (var _d = true, _e = __asyncValues(entry.values()), _f; _f = yield __await(_e.next()), _a = _f.done, !_a; _d = true) {
                        _c = _f.value;
                        _d = false;
                        const handle = _c;
                        yield __await(yield* __asyncDelegator(__asyncValues(this.getFilesRecursively(handle))));
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (!_d && !_a && (_b = _e.return)) yield __await(_b.call(_e));
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        });
    }
}
exports.FileUploader = FileUploader;
class FileDownloader {
    constructor() {
        this.directoryHandle = null;
    }
    // Request permission for a directory handle
    requestPermission(directoryHandle) {
        return __awaiter(this, void 0, void 0, function* () {
            const opts = { mode: "readwrite" };
            // Check if permission is already granted
            // @ts-ignore
            if ((yield directoryHandle.queryPermission(opts)) === "granted") {
                return true;
            }
            // Request permission and return the result
            // @ts-ignore
            return (yield directoryHandle.requestPermission(opts)) === "granted";
        });
    }
    // Select a directory
    selectDirectory() {
        return __awaiter(this, void 0, void 0, function* () {
            // Show directory picker
            // @ts-ignore
            this.directoryHandle = yield window.showDirectoryPicker();
            if (!this.directoryHandle) {
                throw new Error("No directory was selected.");
            }
            // Request permission
            const hasPermission = yield this.requestPermission(this.directoryHandle);
            if (!hasPermission) {
                throw new Error("Permission was not granted for the selected folder.");
            }
        });
    }
    // Create a folder path inside the selected directory
    createFolder(folderPath) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.directoryHandle) {
                throw new Error("No directory handle. Please select a directory first.");
            }
            const folderNames = folderPath.split("/").filter((name) => name.trim() !== "");
            let currentDirectory = this.directoryHandle;
            for (const folderName of folderNames) {
                // Get or create a subdirectory
                currentDirectory = yield currentDirectory.getDirectoryHandle(folderName, { create: true });
            }
            return currentDirectory;
        });
    }
    // Write a file to the directory
    writeFile(filePath, fileName, content) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.directoryHandle) {
                throw new Error("No directory handle. Please select a directory first.");
            }
            const pathParts = filePath.split("/").filter((part) => part.trim() !== "");
            // const fileName = pathParts.pop();
            if (!fileName) {
                throw new Error("Invalid file path. No file name provided.");
            }
            // Create folders if necessary
            let currentDirectory = this.directoryHandle;
            if (filePath !== "") {
                currentDirectory = yield this.createFolder(filePath);
            }
            // Create a file handle and write the content
            const fileHandle = yield currentDirectory.getFileHandle(fileName, {
                create: true,
            });
            const writable = yield fileHandle.createWritable();
            if (typeof content === "string") {
                yield writable.write(content);
            }
            else {
                yield writable.write(content);
            }
            yield writable.close();
        });
    }
}
exports.FileDownloader = FileDownloader;
exports.AWS_REGIONS = [
    ["US East (N. Virginia)", "us-east-1"],
    ["US East (Ohio)", "us-east-2"],
    ["US West (N. California)", "us-west-1"],
    ["US West (Oregon)", "us-west-2"],
    ["Africa (Cape Town)", "af-south-1"],
    ["Asia Pacific (Hong Kong)", "ap-east-1"],
    ["Asia Pacific (Hyderabad)", "ap-south-2"],
    ["Asia Pacific (Jakarta)", "ap-southeast-3"],
    ["Asia Pacific (Kuala Lumpur)", "ap-southeast-5"],
    ["Asia Pacific (Melbourne)", "ap-southeast-4"],
    ["Asia Pacific (Mumbai)", "ap-south-1"],
    ["Asia Pacific (Osaka)", "ap-northeast-3"],
    ["Asia Pacific (Seoul)", "ap-northeast-2"],
    ["Asia Pacific (Singapore)", "ap-southeast-1"],
    ["Asia Pacific (Sydney)", "ap-southeast-2"],
    ["Asia Pacific (Tokyo)", "ap-northeast-1"],
    ["Canada (Central)", "ca-central-1"],
    ["Canada West (Calgary)", "ca-west-1"],
    ["Europe (Frankfurt)", "eu-central-1"],
    ["Europe (Ireland)", "eu-west-1"],
    ["Europe (London)", "eu-west-2"],
    ["Europe (Milan)", "eu-south-1"],
    ["Europe (Paris)", "eu-west-3"],
    ["Europe (Spain)", "eu-south-2"],
    ["Europe (Stockholm)", "eu-north-1"],
    ["Europe (Zurich)", "eu-central-2"],
    ["Israel (Tel Aviv)", "il-central-1"],
    ["Middle East (Bahrain)", "me-south-1"],
    ["Middle East (UAE)", "me-central-1"],
    ["South America (São Paulo)", "sa-east-1"],
    ["AWS GovCloud (US-East)", "us-gov-east-1"],
    ["AWS GovCloud (US-West)", "us-gov-west-1"],
];
